
export const STAR_WARS_COLLECTION_ID = "2423569"